import WildAppResource from "./WildAppResource";
import LuStateAppResource from './LuStateAppResource';
import LuAccountTypeAppResource from './LuAccountTypeAppResource';
import LuEmailStatusAppResource from "./LuEmailStatusAppResource";
import BrokerAppResource from "./BrokerAppResource";
import EmailAppResource from "./EmailAppResource";
import FileAppResource from "./FileAppResource";
import ProfessionalLicenseAppResource from "./ProfessionalLicenseAppResource";
import Engine from "ss-js-engine/src/Engine";
class UserAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'user';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'users';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'integrations',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'isBrokerOwner',
            'isPremiumAgent',
            'isSuperAdmin',
            'hasBillingCard',
            'hasViewedOnboardingVideos',
            'email',
            'firstName',
            'lastName',
            'phone',
            'password',
            'passwordConfirmation',
            'defaultPersonalizedMessage',
            'emailChangeCandidate',
            'emailProofToken',
            'entryToken',
            'headshotUploadFd',
            'headshotUploadMime',
            'passwordResetToken',
            'stripeCustomerId',
            'quickbooksCustomerId',
            'tosAcceptedByIp',
            'unrecognizedBrokerCompanyName',
            'welcomeMessage',
            'zohoId',
            'oAuthCode',
            'emailProofTokenExpiresAt',
            'entryTokenExpiresAt',
            'onboardingCompletedAt',
            'lastSeenAt',
            'passwordResetTokenExpiresAt',
            'oAuthCodeExpiresAt',
            'brokerUuid',
            'boardUuid',
            'referringPlatformUuid',
            'emailStatusId',
            'accountTypeId',
            'stateId',
            'additionalEmails',
            'facebook',
            'linkedin',
            'website',
            'tiktok',
            'instagram',
            'twitter',
            'youtube',
            'invitationMsg',
            'dashboardMsg',
            'jobTitle',
            'displayName',
            'timezone',
            'systemEmails',
            'avatarFileUuid',
            'companyLogoFileUuid',
            'permissionToTextPhone',
            'licenses',
            'nrds'
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            accountType: LuAccountTypeAppResource,
            state: LuStateAppResource,
            emailStatus: LuEmailStatusAppResource,
            broker: BrokerAppResource,
            additionalEmails: EmailAppResource,
            avatarFile: FileAppResource,
            companyLogoFile: FileAppResource,
            licenses: ProfessionalLicenseAppResource,
            nrds: ProfessionalLicenseAppResource
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            accountType: 'account_type_id',
            state: 'state_id',
            emailStatus: 'email_status_id',
            broker: 'broker_uuid',
            avatarFile: 'avatar_file_uuid',
            companyLogoFile: 'company_logo_file_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            password: {
                type: 'string',
                presence: !this.exists,
                confirmed: true,
                length: {
                    minimum: 8,
                    maximum: 255,
                },
            },
            passwordConfirmation: {
                type: 'string',
                presence: !this.exists,
            },
        };
    }

    apiPaths () {
        return {
            ...super.apiPaths(),
            'acceptConnection': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/accept-connection/{contactUuid}'),
            'getConnections': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/connections'),
            'sendConnection': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/send-connection-request'),
            'disconnectConnection': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/disconnect/{contactUuid}'),
            'updateConnection': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/update-connection/{contactUuid}'),
            'sendReminder': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/send-reminder/{contactUuid}'),
            'notifyAgent': Engine.apiUrl(this.appResourceApiPrefix() + '/{uuid}/notify-agent'),
        }
    }

    async accept(contactUuid, viewCompletedDocs = false, shareAllProperties = false) {
        const url = this.apiPaths().acceptConnection.replace('{uuid}', this.uuid).replace('{contactUuid}', contactUuid);
        try{
            let resp = await Engine.post(url, {
                viewCompletedDocs: viewCompletedDocs,
                shareAllProperties: shareAllProperties
            });
            return resp._rawData.data;
        }catch(e){
            return null;
        }
    }

    async getConnections() {
        const url = this.apiPaths().getConnections.replace('{uuid}', this.uuid);
        try{
            let resp =  await Engine.get(url);
            return resp._rawData.data;
        }catch(e){
            return [];
        }
    }

    async sendConnection(data, viewCompletedDocs = false, shareAllProperties = false){
        const url = this.apiPaths().sendConnection.replace('{uuid}', this.uuid);
        try{
            let resp = await Engine.post(url,{
                ...data,
                viewCompletedDocs: viewCompletedDocs,
                shareAllProperties: shareAllProperties
            });
            return resp._rawData.data;
        }catch(e){
            return null;
        }
    }

    async disconnectConnection(contactUuid){
        const url = this.apiPaths().disconnectConnection.replace('{uuid}', this.uuid).replace('{contactUuid}', contactUuid);
        try{
            let resp = await Engine.post(url);
            return resp._rawData.data;
        }catch(e){
            return null;
        }
        
    }

    async sendReminder(contactUuid){
        const url = this.apiPaths().sendReminder.replace('{uuid}', this.uuid).replace('{contactUuid}', contactUuid);
        try{
            let resp = await Engine.post(url);
            return resp._rawData.data;
        }catch(e){
            return null;
        }
    }

    async notifyAgent(contactUuid, orderUuid){
        const url = this.apiPaths().notifyAgent.replace('{uuid}', this.uuid);
        try{
            let resp = await Engine.post(url,{
                contactUuid: contactUuid,
                orderUuid: orderUuid
            });
            return resp._rawData.data;
        }catch(e){
            return null;
        }
    }

    async updateConnection(contactUuid,viewCompletedDocs = false, shareAllProperties = false) {
        const url = this.apiPaths().updateConnection.replace('{uuid}', this.uuid).replace('{contactUuid}', contactUuid);
        try {
            let resp = await Engine.post(url, {
                viewCompletedDocs: viewCompletedDocs,
                shareAllProperties: shareAllProperties
            });
            return resp._rawData.data;
        } catch(e) {
            return null;
        }
    }


}

export default UserAppResource;
